import React, { useEffect, useState } from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { useRest } from '../../contexts/rest/use'
import { useConfig } from '../../contexts/config/use'
import Typography from '@material-ui/core/Typography'
import Room from '@material-ui/icons/Room'
import IconButton from '@material-ui/core/IconButton'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction' 
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'

export const OfficeList = ({offices, filter}) => {
  const { actions: { handleOfficeSelection }} = useRest();
  const { state: { config }} = useConfig();
  const [filteredoffices, setFilteredOffices] = useState();
  const theme = useTheme();
  const classes = useStyles(theme);

  const handleClick = (officeID) => {
    handleOfficeSelection(officeID);
  }

  const getDistanceText = () => {
    return config ? config.distanceUnit.substr(0,2).toLowerCase() === "ki" || config.distanceUnit.substr(0,2).toLowerCase() === "km" ? "km" : "mi" : "mi"
  }

  useEffect(() => {
    let filteredOffices = filter ? offices.filter(x => x.name === filter || Object.values(x.address).some(y => y === filter)) : offices;
    setFilteredOffices(filteredOffices);
  }, [offices, filter])

  const generate = ({offices}) => {
    let tmp_offices = filteredoffices || offices;
    tmp_offices = tmp_offices.sort((a,b) => (a.distance - b.distance));
    return tmp_offices.map((x, i) => {return <ListItem key={"list_item_" + i}>
                                                <Paper elevation={3} className={classes.paper} onClick={() => handleClick(x.officeID)}>
                                                  <ListItemText
                                                    primary={<Typography className="landing-office-listitem-officenames">{x.name}</Typography>}
                                                    secondary={ <div>
                                                                  <Typography className="landing-office-listitem-officedescriptions">{x.address.street}</Typography>
                                                                  <Typography className="landing-office-listitem-officedescriptions">{ x.address.zipcode + " " + x.address.city} </Typography>
                                                                </div>
                                                              }
                                                  />
                                                { x.distance 
                                                ? 
                                                <ListItemSecondaryAction className={classes.distancecontainer}>
                                                  <Typography className="landing-office-listitem-distances">
                                                    { String(x.distance + getDistanceText())}
                                                  </Typography>
                                                  <IconButton>
                                                    <Room className={[classes.icon, "icons"].join(' ')} id="landing-office-distanceicon"/>
                                                  </IconButton>
                                                </ListItemSecondaryAction>
                                                : <span/>}
                                                </Paper>
                                              </ListItem>
    })
  }

  return (
    <List dense={false} style={{width: '100%'}}>        
      {offices ? generate({offices}) : <span/>}
    </List>
  )
}

const useStyles = makeStyles({
  icon: theme => ({
    color: theme.palette.primary.main,
    transform:"scale(1.5)"
  }),
  distancecontainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  paper: {
    width: '100%',
    paddingLeft: '1rem'
  }
})